export default {
  SET_FINE_PRINTS (state, fine_prints) {
    state.fine_prints = fine_prints
  },
  REMOVE_RECORD (state, itemId) {
    const featureCategoryIndex = state.fine_prints.findIndex((u) => u.id === itemId)
    state.fine_prints.splice(featureCategoryIndex, 1)
  }
}
